module.exports = __webpack_public_path__ + "img/preview-3.2501217e.png";